import { useCallback, useEffect, useState } from "react";
import { FieldPathByValue, FieldValues, UseFormReturn } from "react-hook-form";
import { ObjectSchema } from "yup";

type Props<TFieldValues extends FieldValues> = {
  formProps: UseFormReturn<TFieldValues>;
  name?: FieldPathByValue<TFieldValues, any>;
  schemaToValidate: ObjectSchema<any>;
  pathsToValidate: FieldPathByValue<TFieldValues, any>[];
  context?: any;
};

const useIsStepValid = <TFieldValues extends FieldValues>(
  props: Props<TFieldValues>,
) => {
  const { formProps, name, schemaToValidate, pathsToValidate, context } = props;
  const [stepValid, setIsStepValid] = useState(false);
  const validate = useCallback(
    (values: TFieldValues) => {
      try {
        pathsToValidate.forEach((path) => {
          schemaToValidate.validateSyncAt(path, values, {
            context,
          });
        });
        setIsStepValid(true);
      } catch {
        setIsStepValid(false);
      }
    },
    [pathsToValidate, schemaToValidate, context],
  );
  useEffect(() => {
    validate(formProps.getValues());
    const subscription = formProps.subscribe({
      name: name,
      formState: { values: true },
      callback: async (data) => {
        validate(data.values);
      },
    });
    return subscription;
  }, [formProps, name, validate]);
  return { stepValid };
};

export default useIsStepValid;
